import React from "react";
import { Link, Switch, Route } from "react-router-dom";

import Tile from "./shared/components/Tile/Tile";
import basestyles from "./shared/styles/basestyles.module.css";
import homestyles from "./shared/styles/home.module.css";
import PatientRoutes from "./patient/pages/PatientRegisterRoutes/PatientRegister";
import DoctorRoutes from "./doctor/pages/DoctorRegisterRoutes/DoctorRegister";
import InsuranceRegister from "./insurance/pages/InsuranceRegisterRoutes/InsuranceRegister";
import HospitalRegister from "./hospital/pages/HospitalRegisterRoutes/HospitalRegister";
import EmergencyRoute from "./emergency/pages/EmergencyRoutes/EmergencyRoutes";

function Home() {
  return (
    <div className={homestyles.containerHome}>
      <div className={basestyles.container}>
        <h1>
          <p>docs</p>
          <p>on</p>
          <p>blocks</p>
        </h1>
      </div>
      <div className={basestyles.container}>
        <Link to="/patient">
          <Tile name="Patient" type="round" icon="user" />
        </Link>
        <Link to="/doctor">
          <Tile name="Doctor" type="round" icon="user-md" />
        </Link>
        <Link to="/hospital">
          <Tile name="Hospital" type="round" icon="hospital" />
        </Link>
        <Link to="/insurance">
          <Tile name="Insurance " type="round" icon="heartbeat" />
        </Link>
        <Link to="/emergency">
          <Tile name="Emergency" type="round" icon="plus-square" />
        </Link>
      </div>
    </div>
  );
}

export default function Router() {
  return (
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/patient" component={PatientRoutes} />
      <Route path="/doctor" component={DoctorRoutes} />
      <Route path="/insurance" component={InsuranceRegister} />
      <Route path="/hospital" component={HospitalRegister} />
      <Route path="/emergency" component={EmergencyRoute} />
    </Switch>
  );
}
